// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function WifiHighIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M17.5 25.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm12.135-14.625a21.5 21.5 0 0 0-27.27 0 1 1 0 0 0 1.27 1.546 19.5 19.5 0 0 1 24.73 0 1 1 0 0 0 1.27-1.546Zm-4.01 4.471a15.5 15.5 0 0 0-19.243 0 1 1 0 1 0 1.243 1.568 13.5 13.5 0 0 1 16.758 0 1.002 1.002 0 0 0 1.614-.899 1.002 1.002 0 0 0-.372-.669Zm-4.032 4.47a9.506 9.506 0 0 0-11.178 0 1 1 0 1 0 1.178 1.618 7.5 7.5 0 0 1 8.822 0 1 1 0 0 0 1.178-1.618Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
